import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Box } from 'rebass/styled-components';
import theme from 'styled-theming';

const borderColor = theme('mode', {
  light: (props) => props.theme.colors.darkBlue,
  dark: (props) => props.theme.colors.midLightGrey,
});

const loadingAnimation = keyframes`
  to {transform: rotate(360deg);}
`;

const LoadingTemplate = styled(Box)`
  content: '';
  box-sizing: border-box;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  border-radius: 50%;
  border-top: 2px solid ${borderColor};
  border-right: 2px solid transparent;
  animation: ${loadingAnimation} 0.6s linear infinite;
`;

const Loading = (props) => <LoadingTemplate data-testid="loading-spinner" {...props} />;

export default Loading;
